import React from 'react';
import { Trans } from 'react-i18next';

import { Box } from 'components/library';

import * as S from './styled';

import CancelButton from './CancelButton';

const CancelSubscriptionBlock = ({
  date,
  isOneTimeProduct = false,
  onCancel,
  paddingTop,
}: {
  date: string;
  isOneTimeProduct?: boolean;
  paddingTop?: number;
  onCancel: () => void;
}) => {
  return isOneTimeProduct ? (
    <S.OneTimeDisclaimer type="caption" color="text-secondary-subdued">
      <Trans i18nKey="subscription.oneTime.disclaimer" values={{ date }} />
    </S.OneTimeDisclaimer>
  ) : (
    <Box $paddingTop={paddingTop}>
      <CancelButton onCancel={onCancel} />
    </Box>
  );
};

export default CancelSubscriptionBlock;
